import { COLLABORATOR_LEGACY_SESSION_KEY, COLLABORATOR_LEGACY_STORAGE_PREFIX } from "../../lib/collaboratorApi";

export const COLLABORATOR_PORTAL_ENABLED = true;

export function sanitizeCollaboratorStorage(storage = window.localStorage) {
  storage.removeItem(COLLABORATOR_LEGACY_SESSION_KEY);

  const keys = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key && key.startsWith(COLLABORATOR_LEGACY_STORAGE_PREFIX)) {
      keys.push(key);
    }
  }

  keys.forEach((key) => {
    storage.removeItem(key);
  });
}
